import fetch from './_defaults/fetch'

export async function createUser({ data }) {

    try {
        const response = await fetch.post("/auth/oauth/credentials", data);

        return response;

    } catch (error) {
        console.log("ERROR createUser");
        throw error;
    }
}

export async function getUsers({ params } = {}) {

    try {
        const response = await fetch.get(`/users`, { params });
        return response;

    } catch (error) {
        console.log('ERROR getUsers')
        console.log(error)
        return []
    }
}

export async function getUser({ userId }) {

    try {
        const response = await fetch.get(`/users/${userId}`)
        console.log(response)
        return response
    } catch (error) {
        console.log('ERROR getUser')
        console.log(error)
        return {}
    }
}

export async function updateUser({ userId, data }) {

    try {
        const response = await fetch.post(`/users/${userId}`, data)

        return response
    } catch (error) {
        console.log('ERROR updateUser')
        console.log(error)
        throw error
    }
}

export async function removeUser({ userId, data }) {

    try {
        const response = await fetch.remove(`/users/${userId}`, data)

        return response
    } catch (error) {
        console.log('ERROR removeUser')
        console.log(error)
        throw error
    }
}
